module.exports = __webpack_public_path__ + "img/Lightning_in_a_bottle.3dfa022e.jpg";